import styled, { css } from 'styled-components';

export const LoaderContainer = styled.div<{ disabeldPadding: boolean }>`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  padding: 3rem 0;

  ${({ disabeldPadding }) =>
    disabeldPadding &&
    css`
      padding: 0;
    `}
`;
